import { PasscodeList } from '../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';

export interface PasscodeTileProps {
	list: PasscodeList;
	onClick: () => void;
}

function formatNumber(num: number) {
	return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function formatTime(date: Date) {
	return new Date(date).toLocaleDateString(navigator.language, {
		weekday: 'short',
		month: 'short',
		day: '2-digit',
		year: 'numeric',
	});
}

function formatType(type: number) {
	switch (type) {
		case 0: {
			return <span>Email only</span>;
		}
		case 1: {
			return <span>Passcode only</span>;
		}
		case 2: {
			return <span>Passcode and Email</span>;
		}
		default: {
			return <span>- Type not found -</span>;
		}
	}
}

export default function PasscodeTile(props: PasscodeTileProps): JSX.Element {
	const { list, onClick } = props;

	return (
		<div key={list.uuid} className="passcode-tile">
			<div className="passcode-header">
				<button onClick={onClick} className="no-style no-padding">
					{list.name ? (
						<div className="passcode-name">
							<h5>{list.name}</h5>
						</div>
					) : (
						<div className="passcode-name">
							<h5>- No Title -</h5>
						</div>
					)}
				</button>
				<button className="passcode-edit no-style" onClick={onClick}>
					<Icon
						name={ICONS.THREE_DOTS_VERTICAL}
						size={18}
						color={COLORS.DEFAULT_GRAY}
					/>
				</button>
			</div>
			<div className="passcode-members">
				<p>
					<strong>{formatNumber(list.member_count)}</strong> members
				</p>
			</div>
			<div className="passcode-type">
				<p>{formatType(Number(list.type))}</p>
				<p>{formatTime(list.created_at)}</p>
			</div>
		</div>
	);
}
